@if (possibleTransferPoints?.length || trajectory?.length) {
  <label class="fw-bold my-2 mb-3">Pilot boarding per trajectory</label>
  @for (pilotage of trajectory; track pilotage.pilotTransferPointId; let index = $index; let last = $last) {
    <div class="row gx-2 position-relative">
      <div [ngClass]="!last ? 'line-before' : ''" class="col-auto d-flex align-items-center">
        <app-sequence-badge [index]="index"></app-sequence-badge>
      </div>
      <div class="col">
        <div>
          {{pilotage.name}}
        </div>
        <div>
          <app-yes-no [(ngModel)]="pilotage.pilotRequired"></app-yes-no>
        </div>
      </div>
      @if (last) {
        <div class="col-1">
          <a class="btn rounded-circle p-1 text-danger h1 mb-0 action-btn"
            type="button" (click)="deletePilotTransferPoint(pilotage)">
            <i class="fa-fw fa-light fa-trash-can"></i>
          </a>
        </div>
      }
    </div>
  }
  <div class="row mb-3" [ngClass]="trajectory?.length ? 'pt-3' : ''">
    <div class="ms-auto col-auto dropdown">
      <a role="button" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="$event.preventDefault();">
        Add pilot boarding per trajectory
      </a>
      <div class="dropdown-menu">
        @for (pilotage of filteredPossibleTransferPoints; track $index) {
          <button class="btn dropdown-item" (click)="addNewPilotTransferPoint(pilotage)">
            {{pilotage.name}}
          </button>
        }
      </div>
    </div>
  </div>
}
